import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgDesktopSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M8 14V11M8 14H5M8 14H11M8 11H12C13.6569 11 15 9.65685 15 8V2H1V11H8Z"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);

SvgDesktopSmall.displayName = 'SvgDesktopSmall';
const DesktopSmall = withForgeIconProps(SvgDesktopSmall, {
  name: 'Desktop',
  usage: 'Use to represent a computer',
  related: 'N/A',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'small',
});
export default DesktopSmall;
